import { render } from "./TagsElement.vue?vue&type=template&id=1b5eee02"
import script from "./TagsElement.vue?vue&type=script&lang=js"
export * from "./TagsElement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__